import { Box, Button, List, ListItem, ListItemIcon, ListItemText, Modal, styled, Typography, useTheme } from "@mui/material";
import { IconCheck } from "@tabler/icons-react";

const BoxWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  padding: "30px 50px",
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
  "& .BtnWrapper": {
    "& button": {
      textTransform: "none",
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      borderRadius: "5px",
      boxShadow: "none",
      padding: "7px 22px",
      whiteSpace: "nowrap",
      width: "100%",
      "&:focus": {
        outline: "none",
      },
      "&.OutlineBtn": {
        textTransform: "none",
        backgroundColor: "transparent",
        color: "#45C0CB",
        borderRadius: "5px",
        boxShadow: "none",
        border: "1px solid #45C0CB",
        padding: "11px 22px 9px",
        fontWeight: "600",
        "&:focus": {
          outline: "0",
        },
        "&:hover": {
          backgroundColor: "#45C0CB",
          color: "#fff",
        },
        "&.Mui-disabled": {
          opacity: "0.5",
        },
      },
    },
  },
}));

function PlanDetails({ open, handleClose }) {
  // const { userData } = useSelector(state => state.reducer);
  const theme = useTheme();
  return (
    <Modal open={open}>
      <BoxWrapper>
        <Typography variant="subtitle1" fontSize="24px" mb={3} fontWeight={700} lineHeight={1} textAlign="center" color={theme.palette.mode === "dark" ? "#ffffff" : "#2A3547"}>
          FREEMIUM
        </Typography>
        <Box>
          <Box display="flex" justifyContent="center" color={theme.palette.mode === "dark" ? "#ffffff" : "#2A3547"}>
            <Typography fontSize="40px" fontWeight="700">
              1
            </Typography>
            <Typography fontSize="15px" fontWeight={400} ml={1} mt={1}>
              /monthly
            </Typography>
          </Box>
        </Box>
        <Box mt={2}>
          <List>
            <Box>
              <ListItem disableGutters>
                <ListItemIcon sx={{ color: "primary.main", minWidth: "32px" }}>
                  <IconCheck width={18} />
                </ListItemIcon>
                <ListItemText sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#212529" }}>5 Projects</ListItemText>
              </ListItem>
            </Box>
            <Box>
              <ListItem disableGutters>
                <ListItemIcon sx={{ color: "primary.main", minWidth: "32px" }}>
                  <IconCheck width={18} />
                </ListItemIcon>
                <ListItemText sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#212529" }}>5000 Site audit</ListItemText>
              </ListItem>
            </Box>
            <Box>
              <ListItem disableGutters>
                <ListItemIcon sx={{ color: "primary.main", minWidth: "32px" }}>
                  <IconCheck width={18} />
                </ListItemIcon>
                <ListItemText sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#212529" }}>1 Blog generation</ListItemText>
              </ListItem>
            </Box>
            <Box>
              <ListItem disableGutters>
                <ListItemIcon sx={{ color: "primary.main", minWidth: "32px" }}>
                  <IconCheck width={18} />
                </ListItemIcon>
                <ListItemText sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#212529" }}>0 Keyword rankings</ListItemText>
              </ListItem>
            </Box>
            <Box>
              <ListItem disableGutters>
                <ListItemIcon sx={{ color: "primary.main", minWidth: "32px" }}>
                  <IconCheck width={18} />
                </ListItemIcon>
                <ListItemText sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#212529" }}>0 Keyword researches</ListItemText>
              </ListItem>
            </Box>
          </List>
        </Box>
        <Box className="BtnWrapper">
          <Button className="OutlineBtn" onClick={handleClose}>
            Close
          </Button>
        </Box>
      </BoxWrapper>
    </Modal>
  );
}

export default PlanDetails;
